import React, { ReactNode } from 'react'
import { InfoButton } from 'src/components/PageLayout/InfoButton'
import { Tooltip, TooltipOverlayType, TooltipPositions } from './Tooltip'

export const InfoTooltip = ({
  id,
  body,
  placement,
  overlay,
  markdown,
  learnMoreHref,
  noMargin,
  hideArrow,
  compact,
}: {
  id: string
  // ReactNode, not string: Tooltip's own tooltipBody has always accepted a
  // node, and narrowing it here pushed callers with structured content into
  // faking it with markdown -- which then renders literal underscores and
  // autolinks anything that looks like an email.
  body?: ReactNode
  placement?: TooltipPositions
  overlay?: TooltipOverlayType
  markdown?: string
  learnMoreHref?: string
  noMargin?: boolean
  hideArrow?: boolean
  compact?: boolean
}): JSX.Element => (
  <Tooltip
    id={id}
    placement={placement || TooltipPositions.right}
    overlayType={overlay || TooltipOverlayType.popover}
    tooltipBody={body}
    markdown={markdown}
    learnMoreHref={learnMoreHref}
    hideArrow={hideArrow}
    compact={compact}
  >
    <InfoButton as="span" ml={noMargin ? undefined : 'xs'} />
  </Tooltip>
)
